<template>
    <BreadCrumb PageTitle="Configuration des checks de validation" />
     <AddModalValidationCheck/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalValidationCheck from "@/components/ValidationCheck/AddModalValidationCheck.vue";
  
    export default defineComponent({
      name: "AddValidationCheckPage",
      components: {
        BreadCrumb,
        AddModalValidationCheck,
      },
    });
  </script>